import { render } from "./ranking.vue?vue&type=template&id=804278ca&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"

import "./ranking.vue?vue&type=style&index=0&id=804278ca&scoped=true&lang=css"

import exportComponent from "E:\\waibao\\isa-community-toupin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804278ca"]])

export default __exports__